import { useIsAuthenticated } from '@azure/msal-react';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

function RequireAuth({ children }: Props) {
  const isAuthenticated = useIsAuthenticated();

  return <>{isAuthenticated === true ? children : null}</>;
}

export default RequireAuth;
